import { DD, DT, FormField, GridCol, GridRow, Select, Typography } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { FormValues, FormPath } from '../agreement-conditions-card.component';
import { useGetCompaniesByIdDepartmentsQuery } from '@client/api';
import { useMemo } from 'react';
interface DepartmentProps {
  isFetching: boolean;
  editing: boolean;
  managerId?: string | null;
  departmentId?: number | null;
}

export const Department = ({ isFetching, editing, departmentId, managerId }: DepartmentProps) => {
  const { t: tGlobal } = useTranslation('global');
  const { data: departments } = useGetCompaniesByIdDepartmentsQuery(
    {
      id: managerId || '',
    },
    {
      skip: !managerId,
    },
  );

  const department = useMemo(() => departments?.find((d) => d.id === departmentId), [departments, departmentId]);

  return (
    <div className="py-2" data-testid="department">
      <Typography variant="none" className="mb-4 text-brand-primary font-medium uppercase text-xs">
        {tGlobal('agreement.department')}
      </Typography>

      <GridRow cols={3} spacing={2} className="items-center">
        <GridCol span={1}>
          <DT>{tGlobal('agreement.departmentName')}</DT>
        </GridCol>
        <GridCol span={2} loading={isFetching}>
          {!editing ? (
            <DD isEmpty={!department}>{department?.name || '-'}</DD>
          ) : (
            <FormField<FormValues, FormPath>
              name="departmentId"
              render={({ field }) => (
                <Select size="medium" {...field}>
                  <option value="" />
                  {departments?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Select>
              )}
            />
          )}
        </GridCol>
      </GridRow>
    </div>
  );
};
